export default __webpack_public_path__ + "static/media/background-numbers.f5638eb8.jpg";